const Fields = {
   // Application: `
   //   name
   //   fatherName
   //   `,
   createApplication: `
     name
     fatherName
     `,
    updateApplication: `
     name
     fatherName
     `,
    allApplications: `
     id
     photo
     name
     fullName
     createdBy
     modifiedBy
     fatherName
     date
     status
     `,

    // Record: `
    //  name
    //  fatherName
    //  `,
    createRecord: `
     name
     fatherName
     `,
    updateRecord: `
     name
     fatherName,
     fullName,
     registrationId
     `,
    allRecords: `
      name
      _id
      fatherName
      gFatherName
      fullName
      date
      registrationId
      accountHolder
      photo
      official
      createdBy
      modifiedBy
      birthDate
      place {
        address {
          subcity
          area
          locationText
        }
      }
      `,
 allVisits: `
     name
     _id
     fatherName
     gFatherName
     name
     date
     registrationId
     photo
     createdBy
     modifiedBy
     category
     `,
allPosts: `date
 title
 recordId
 type
 files {
  filePath
  title
 }
 body`,

    // AccountHolder: `
    //   name
    //   banks
    //   `,
    createAccountHolder: `
      name
      banks {
        bankName
        accountNumber
      }
      `,
    updateAccountHolder: `
      name
      banks {
        _id
        bankName
        accountNumber
      }
      `,
    allAccountHolders: `
      id
      name
      banks {
        _id
        bankName
        accountNumber
      }
      beneficiaries {
        id
        registrationId
        name
        fatherName
        monthlyAllowance
      }
      createdBy
      modifiedBy
      `,

    // PaymentPeriod: `
    //   month
    //   label
    //   status
    //   `,
    allPaymentPeriods: `
      id
      month
      label
      status
      approvedAt
      paidAt
      `,

    // User: the composed update only carries email. Roles are NOT writable
    // through the composed path any more - they moved to the setUserRoles
    // mutation so that it can enforce the rules about the last super-admin. If
    // `roles` ever appears back on UpdateByIdUserInput, that guarantee is gone.
    //
    // There is deliberately NO `oneUser` entry. GET_ONE resolves to the `User`
    // query - the findById resolver, which takes `_id` - and NOT to `oneUser`,
    // the findOne resolver, which takes a `filter`. graphDataProvider's GET_ONE
    // template addresses by `_id`, so `User` is the key that would matter here
    // and `oneUser` would never be consulted.
    //
    // `createdBy` / `modifiedBy` are not listed because the field list is only
    // used for the list and edit queries; the show page falls back to the full
    // type, which carries them. They are ids, and the show page resolves them to
    // an email through ReferenceField.
    allUsers: `
      id
      email
      roles
      `,
    updateUser: `
      id
      email
      `,

}

export default Fields;
